export let action = {
    normal: 1,
    remove: 2,
    moveprev: 3,
    movenext: 4
}

export let modaltype = {
    ckeditor: 0,
    width: 1
}

export let rowtype = {
    row: 'row',
    column: 'column',
    editor: 'editor',
    vue: 'vue'
}